module.exports = __webpack_public_path__ + "img/档案盒打印机.fa3009be.jpg";